import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasValue',
  standalone: false
})
export class HasValuePipe implements PipeTransform{
    transform(value: any)  {
        if(value === undefined || value === null){
            return "----";
        }

        if(value === '' || value === " " || value === '/' || value.length === 0){
            return "----";
        }

        return value;
    }
}